// extracted by mini-css-extract-plugin
export var headerTitle = "BlogHeader__headerTitle-Ljs1f";
export var iconLogo = "BlogHeader__iconLogo-fvMAT";